import { FC, memo } from 'react'
import Spinner from '@app/components/Spinner'
import * as S from './SmoothLoading.styles'

interface SmoothLoadingProps {
  locale: string
}

const LOCALE_TEXTS = {
  fr: 'Chargement de votre expérience...',
  de: 'Ihr Erlebnis wird geladen ...',
  it: 'Caricamento della tua esperienza...',
  es: 'Cargando su experiencia...',
  default: 'Loading your experience...',
} as const

const containerVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
}

const containerTransition = {
  duration: 0.3,
  ease: 'easeOut' as const,
}

const SmoothLoading: FC<SmoothLoadingProps> = memo(({ locale }) => {
  const text = LOCALE_TEXTS[locale as keyof typeof LOCALE_TEXTS] || LOCALE_TEXTS.default

  return (
    <S.Container
      variants={containerVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={containerTransition}>
      <Spinner size={64} />
      <S.Text>{text}</S.Text>
    </S.Container>
  )
})

export default SmoothLoading
